export const SearchTypeKeyword = 1 as const;
export type TSearchTypeKeyword = typeof SearchTypeKeyword;

export enum KeywordType {
	MATCH_ALL_FRAGMENTS = 4,
	MATCH_ANY_FRAGMENT = 5,
	MATCH_EXACTLY = 1,
	MATCH_EXACTLY_INCLUDING_DIACRITICAL_MARKS = 10,
	MATCH_EXCLUDE = 3,
	MATCH_ALL_WHOLE_WORDS_AND = 0,
	MATCH_ANY_WHOLE_WORDS_OR = 2,
}
